import { useContext } from 'react';
import { PracticePayersContext } from './context';
import { PracticePayersContextProps } from './types';

export const usePracticePayers = (): PracticePayersContextProps => {
  const context = useContext(PracticePayersContext);

  if (!context) {
    throw new Error('usePracticePayers must be used within a PracticePayersProvider');
  }

  return context;
};
